import { useEffect } from 'react';

import Loading, { LoadingScale } from 'bloko/blocks/loading';

import useTrls from 'hooks/translation/useTrls';

import Table from 'components/Table';

import fetchActs from 'components/Admin/InvoiceDetail/Acts/fetchActs';
import Filter, { DEFAULT_FILTER_DATES } from 'components/Admin/InvoiceDetail/Filter';
import TitleWithInvoiceNumber from 'components/Admin/InvoiceDetail/TitleWithInvoiceNumber';
import Act from 'components/Admin/Reports/ActsReport/ActsTable/Act';
import Header from 'components/Admin/Reports/ActsReport/ActsTable/Header';
import TableBody from 'components/Table/TableBody';
import TableHead from 'components/Table/TableHead';

import { useDispatch, useSelector } from 'store/utils';

import 'components/Admin/InvoiceDetail/Acts/Acts.less';

const Acts = () => {
    const { invoiceId, invoice, acts, isLoadActs } = useSelector((state) => state.invoiceDetail);

    const dispatch = useDispatch();

    const trl = useTrls();

    useEffect(() => {
        const dates = DEFAULT_FILTER_DATES(invoice);
        dispatch(fetchActs(invoiceId, dates.from, dates.to));
    }, [dispatch, invoice, invoiceId]);
    return (
        <div className="invoice-acts">
            <TitleWithInvoiceNumber titleBlock={trl('admin.Invoices.InvoicesDetail.Invoice.Acts.title')} {...invoice} />
            <Filter invoiceId={invoiceId} fetchItems={fetchActs} />
            {isLoadActs && <Loading scale={LoadingScale.Medium} />}
            {!isLoadActs && acts.length === 0 && <div>{trl('admin.Invoices.InvoicesDetail.Invoice.Acts.empty')}</div>}
            {!isLoadActs && acts.length > 0 && (
                <Table bordered fullWidth>
                    <TableHead>
                        <Header acts={acts} disableSorts showDate />
                    </TableHead>
                    <TableBody>
                        {acts.map((act, index) => (
                            <Act key={index} act={act} showDate />
                        ))}
                    </TableBody>
                </Table>
            )}
        </div>
    );
};

export default Acts;
